import { createSlice } from '@reduxjs/toolkit'
const initialState = {
  postId: null,
  strapiPost: [],
  currentStrapiPost: {},
}
const theaterSlice = createSlice({
  name: 'theater',
  initialState,
  reducers: {
    updateTheaterState(state, action) {
      state[action.payload.key] = action.payload.value
    },
    updateTheaterSpecific(state, action) {
      if (state.post) {
        state.post.comments = action.payload.comments
        state.post.noOfComments = action.payload.noOfComments
        state.post.noOfReactions = action.payload.noOfReactions
        state.post.reactionId = action.payload.reactionId
      }
    },
    addTheaterSpecificReaction(state, action) {
      const { reactionId, reactionType } = action.payload
      if (state.post) {
        state.post.noOfReactions = state.post.reactionType
          ? state.post.noOfReactions
          : state.post.noOfReactions + 1
        state.post.reactionId = reactionId
        state.post.reactionType = reactionType
      }
    },
    removeTheaterSpecificReaction(state) {
      if (state.post) {
        state.post.noOfReactions = state.post.noOfReactions - 1
        state.post.reactionId = false
        state.post.reactionType = ''
      }
    },
    updatePostData(state, action) {
      if (state.post) {
        const {
          comments,
          noOfComments,
          noOfReactions,
          reactionId,
          reactionType,
          reactions,
        } = action.payload
        state.post = {
          ...state.post,
          comments,
          noOfComments,
          noOfReactions,
          reactionId,
          reactionType,
          reactions,
        }
      }
    },
    updateStrapiPost(state, action) {
      const { postId, data } = action.payload
      const index = state.strapiPost.findIndex(post => post.postId === postId)
      if (index !== -1) {
        state.strapiPost[index] = data
      }
    },
    addStrapiPost(state, action) {
      state.strapiPost.push(action.payload)
    },
    removeStrapiPost(state, action) {
      const { postId } = action.payload
      const index = state.strapiPost.findIndex(post => post.postId === postId)
      if (index !== -1) {
        state.strapiPost.splice(index, 1)
      }
    },
    setStrapiPost(state, action){
      state.currentStrapiPost = action.payload
    }
  },
})

export const theaterReducer = theaterSlice.reducer
export const {
  updateTheaterState,
  updateTheaterSpecific,
  addTheaterSpecificReaction,
  removeTheaterSpecificReaction,
  updatePostData,
  updateStrapiPost,
  addStrapiPost,
  removeStrapiPost,
  setStrapiPost
} = theaterSlice.actions
